import { apiCall } from './gqlClient';

const GETRESOURCES_QUERY = `
  query getResources($providerId: Int, $archivedAsWell: Boolean) {
    getResources(providerId: $providerId, archivedAsWell: $archivedAsWell)
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getResourcesApiCall = async ({providerId, archivedAsWell}, fragments = null) => apiCall({ query: GETRESOURCES_QUERY, variables: {providerId, archivedAsWell}, fragments });

const GETPHYSICALRESOURCES_QUERY = `
  query getPhysicalResources($providerId: Int) {
    getPhysicalResources(providerId: $providerId)
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getPhysicalResourcesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPHYSICALRESOURCES_QUERY, variables: {providerId}, fragments });

const GETALLEVENTSBYRESOURCE_QUERY = `
  query getAllEventsByResource($id: Int!) {
    getAllEventsByResource(id: $id)
    {
      id
			userId
			name
			gender
      ...fragments
    }
  }`;

export const getAllEventsByResourceApiCall = async ({id}, fragments = null) => apiCall({ query: GETALLEVENTSBYRESOURCE_QUERY, variables: {id}, fragments });

const GETALLNOTASSIGNEDRESOURCESONPROVIDER_QUERY = `
  query getAllNotAssignedResourcesOnProvider {
    getAllNotAssignedResourcesOnProvider
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getAllNotAssignedResourcesOnProviderApiCall = async (fragments = null) => apiCall({ query: GETALLNOTASSIGNEDRESOURCESONPROVIDER_QUERY, variables: {}, fragments });

const GETWIDGETRESOURCEAVAILABILITYDATES_QUERY = `
  query getWidgetResourceAvailabilityDates($resourceId: Int!, $subServiceId: Int!, $materialResourceId: Int) {
    getWidgetResourceAvailabilityDates(resourceId: $resourceId, subServiceId: $subServiceId, materialResourceId: $materialResourceId)
    {
      availableDays
			minDate
			maxDate
      ...fragments
    }
  }`;

export const getWidgetResourceAvailabilityDatesApiCall = async ({resourceId, subServiceId, materialResourceId}, fragments = null) => apiCall({ query: GETWIDGETRESOURCEAVAILABILITYDATES_QUERY, variables: {resourceId, subServiceId, materialResourceId}, fragments });

const GETRESOURCEAVAILABILITYDATES_QUERY = `
  query getResourceAvailabilityDates($resourceId: Int!, $subServiceId: Int!, $materialResourceId: Int, $isItDeal: Boolean) {
    getResourceAvailabilityDates(resourceId: $resourceId, subServiceId: $subServiceId, materialResourceId: $materialResourceId, isItDeal: $isItDeal)
    {
      availableDays
			minDate
			maxDate
      ...fragments
    }
  }`;

export const getResourceAvailabilityDatesApiCall = async ({resourceId, subServiceId, materialResourceId, isItDeal}, fragments = null) => apiCall({ query: GETRESOURCEAVAILABILITYDATES_QUERY, variables: {resourceId, subServiceId, materialResourceId, isItDeal}, fragments });

const GETWIDGETRESOURCEAVAILABILITYSLOTS_QUERY = `
  query getWidgetResourceAvailabilitySlots($resourceId: Int!, $subServiceId: Int!, $date: DateTime!, $duration: Int, $reservationId: Int, $materialResource: Int) {
    getWidgetResourceAvailabilitySlots(resourceId: $resourceId, subServiceId: $subServiceId, date: $date, duration: $duration, reservationId: $reservationId, materialResource: $materialResource)
  }`;

export const getWidgetResourceAvailabilitySlotsApiCall = async ({resourceId, subServiceId, date, duration, reservationId, materialResource}, ) => apiCall({ query: GETWIDGETRESOURCEAVAILABILITYSLOTS_QUERY, variables: {resourceId, subServiceId, date, duration, reservationId, materialResource}});

const GETRESOURCEAVAILABILITYSLOTS_QUERY = `
  query getResourceAvailabilitySlots($resourceId: Int!, $subServiceId: Int!, $date: DateTime!, $duration: Int, $reservationId: Int, $isItDeal: Boolean, $materialResource: Int) {
    getResourceAvailabilitySlots(resourceId: $resourceId, subServiceId: $subServiceId, date: $date, duration: $duration, reservationId: $reservationId, isItDeal: $isItDeal, materialResource: $materialResource)
  }`;

export const getResourceAvailabilitySlotsApiCall = async ({resourceId, subServiceId, date, duration, reservationId, isItDeal, materialResource}, ) => apiCall({ query: GETRESOURCEAVAILABILITYSLOTS_QUERY, variables: {resourceId, subServiceId, date, duration, reservationId, isItDeal, materialResource}});

const GETRESOURCESBYSUBSERVICE_QUERY = `
  query getResourcesBySubService($subServiceId: Int!) {
    getResourcesBySubService(subServiceId: $subServiceId)
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getResourcesBySubServiceApiCall = async ({subServiceId}, fragments = null) => apiCall({ query: GETRESOURCESBYSUBSERVICE_QUERY, variables: {subServiceId}, fragments });

const GETRESOURCESBYSERVICE_QUERY = `
  query getResourcesByService($serviceId: Int!) {
    getResourcesByService(serviceId: $serviceId)
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getResourcesByServiceApiCall = async ({serviceId}, fragments = null) => apiCall({ query: GETRESOURCESBYSERVICE_QUERY, variables: {serviceId}, fragments });

const GETOWNERRESOURCES_QUERY = `
  query getOwnerResources {
    getOwnerResources
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getOwnerResourcesApiCall = async (fragments = null) => apiCall({ query: GETOWNERRESOURCES_QUERY, variables: {}, fragments });

const GETCOLLABORATORS_QUERY = `
  query getCollaborators {
    getCollaborators
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
			nextEventAt
			nextEventName
			membershipActive
			membershipExpiresAt
      ...fragments
    }
  }`;

export const getCollaboratorsApiCall = async (fragments = null) => apiCall({ query: GETCOLLABORATORS_QUERY, variables: {}, fragments });

const GETALLARCHIVEDRESOURCES_QUERY = `
  query getAllArchivedResources {
    getAllArchivedResources
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getAllArchivedResourcesApiCall = async (fragments = null) => apiCall({ query: GETALLARCHIVEDRESOURCES_QUERY, variables: {}, fragments });

const GETSUBSERVICESCLASSESBYRESOURCE_QUERY = `
  query getSubservicesClassesByResource($resourceId: Int!) {
    getSubservicesClassesByResource(resourceId: $resourceId)
  }`;

export const getSubservicesClassesByResourceApiCall = async ({resourceId}, ) => apiCall({ query: GETSUBSERVICESCLASSESBYRESOURCE_QUERY, variables: {resourceId}});

const GETINDIVIDUALCOLLABORATORPERCENT_QUERY = `
  query getIndividualCollaboratorPercent($resourceId: Int!) {
    getIndividualCollaboratorPercent(resourceId: $resourceId)
  }`;

export const getIndividualCollaboratorPercentApiCall = async ({resourceId}, ) => apiCall({ query: GETINDIVIDUALCOLLABORATORPERCENT_QUERY, variables: {resourceId}});

const EDITRESOURCE_QUERY = `
  mutation editResource($id: Int!, $name: String!, $gender: String, $role: String, $userId: Int, $capacity: Int) {
    editResource(id: $id, name: $name, gender: $gender, role: $role, userId: $userId, capacity: $capacity)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const editResourceApiCall = async ({id, name, gender, role, userId, capacity}, fragments = null) => apiCall({ query: EDITRESOURCE_QUERY, variables: {id, name, gender, role, userId, capacity}, fragments });

const ARCHIVERESOURCE_QUERY = `
  mutation archiveResource($id: Int!) {
    archiveResource(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const archiveResourceApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVERESOURCE_QUERY, variables: {id}, fragments });

const ARCHIVEWITHREASIGNRESOURCE_QUERY = `
  mutation archiveWithReasignResource($id: Int!, $resourceId: Int!, $past: Boolean!, $future: Boolean!) {
    archiveWithReasignResource(id: $id, resourceId: $resourceId, past: $past, future: $future)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const archiveWithReasignResourceApiCall = async ({id, resourceId, past, future}, fragments = null) => apiCall({ query: ARCHIVEWITHREASIGNRESOURCE_QUERY, variables: {id, resourceId, past, future}, fragments });

const ARCHIVEWITHREASIGNRESOURCETOOWNER_QUERY = `
  mutation archiveWithReasignResourceToOwner($id: Int!) {
    archiveWithReasignResourceToOwner(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const archiveWithReasignResourceToOwnerApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVEWITHREASIGNRESOURCETOOWNER_QUERY, variables: {id}, fragments });

const CREATERESOURCE_QUERY = `
  mutation createResource($request: ResourceCreateInput) {
    createResource(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createResourceApiCall = async ({request}, fragments = null) => apiCall({ query: CREATERESOURCE_QUERY, variables: {request}, fragments });

const RESTOREARCHIVEDRESOURCE_QUERY = `
  mutation restoreArchivedResource($id: Int!) {
    restoreArchivedResource(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const restoreArchivedResourceApiCall = async ({id}, fragments = null) => apiCall({ query: RESTOREARCHIVEDRESOURCE_QUERY, variables: {id}, fragments });

const SAVEINDIVIDUALCOLLABORATORPERCENT_QUERY = `
  mutation saveIndividualCollaboratorPercent($request: IndividualCollaboratorPercentInput!) {
    saveIndividualCollaboratorPercent(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const saveIndividualCollaboratorPercentApiCall = async ({request}, fragments = null) => apiCall({ query: SAVEINDIVIDUALCOLLABORATORPERCENT_QUERY, variables: {request}, fragments });

const UPDATEINDIVIDUALCOLLABORATORPERCENT_QUERY = `
  mutation updateIndividualCollaboratorPercent($id: String!, $amountType: String!, $amount: Float!) {
    updateIndividualCollaboratorPercent(id: $id, amountType: $amountType, amount: $amount)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateIndividualCollaboratorPercentApiCall = async ({id, amountType, amount}, fragments = null) => apiCall({ query: UPDATEINDIVIDUALCOLLABORATORPERCENT_QUERY, variables: {id, amountType, amount}, fragments });

const DELETEINDIVIDUALCOLLABORATORPERCENT_QUERY = `
  mutation deleteIndividualCollaboratorPercent($id: String!) {
    deleteIndividualCollaboratorPercent(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteIndividualCollaboratorPercentApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEINDIVIDUALCOLLABORATORPERCENT_QUERY, variables: {id}, fragments });
